import * as WebFont from "webfontloader"
import { Scale } from "../phaser/utils/Scale"
import { CCUtils } from "./CCUtils"

export class TextUtils {

    static incrementLetter = (letter: string): string => String.fromCharCode(letter.charCodeAt(0) + 1)

    static plural = (quantity: number) => quantity === 1 ? "" : "s"

    private static fontPx = (startPx: number): string => {
        return Math.floor(startPx * Scale.scaleAmount()).toString() + "px"
    }

    static loadFonts = (onComplete?: () => void) => {

        const fonts = CCUtils.enumValues(FontType)
        fonts.push(FontType.BODY + ":400,700,800")
        fonts.push(FontType.NEWS_HEADLINE + ":black")

        // Fonts we use get loaded here.
        WebFont.load({
            google: {
                families: fonts
            },
            classes: false,
            active: onComplete,
            inactive: onComplete,
            timeout: 4000
        } as WebFont.Config)
    }

    static font = (type: FontType, startPx?: number, style?: "Black") =>
        startPx == null ? "" : TextUtils.fontPx(startPx) + " " + type + (style ? ` ${style}` : "")
}

/**
 * Do NOT add any fonts that are not a Google Font. It will break this in prod, but not local dev.
 */
export enum FontType {
    HEADER = "Oswald", // Like "Addiction Pong"
    TITLE = "Rubik", // Displayed on pages as a title
    SILLY_TITLE = "Luckiest Guy", // For experiments
    SCIENTIFIC_TITLE = "Black Ops One", // For things like molecules
    HAND_WRITING = "Caveat Brush", // Hand written text like in Camp Cravings
    BODY = "Open Sans", // All the normal text
    MONOSPACE = "Source Code Pro", // For faux-old computer text
    FUTURISTIC = "Audiowide", // For things like time machine
    NEWS_HEADLINE = "Cinzel",
    PLAY = "Play", // For Make A Video activity, similar to ITC Eras
    ANTON = "Anton", // For Definition of a Smoker
    NEWSPAPER = "Playfair Display", // Used on Personality Newspaper article
    ROBOTO = "Roboto", // Student login default
    ARCHIVO_BLACK = "Archivo Black", // Student login headers
}

export enum Align {
    LEFT = "left",
    CENTER = "center",
    RIGHT = "right",
}
